import axios from "axios";
import React, { useContext, useEffect, useState, useMemo } from "react";
import { AuthContext } from "../../context/AuthContext";
import { FaHotel } from "react-icons/fa";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import "./topDashboard.scss";
import { IoWalletSharp } from "react-icons/io5";
import { GiBookCover } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../loading/Loading";
import { TbPigMoney } from "react-icons/tb";
import { FaShoppingCart } from "react-icons/fa";
import { FaBoxes } from "react-icons/fa";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TopDashboard = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const getAllProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-all-products");
        setProduct(response.data);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };
    getAllProduct();
  }, []);

  useEffect(() => {
    const getAllProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-all-orders");
        setOrders(response.data);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };
    getAllProduct();
  }, []);

  // totals
  const totalProduct = product.length;
  const paidOrders = useMemo(
    () => orders.filter((o) => o.paymentStatus === "Paid"),
    [orders]
  );
  const totalOrders = paidOrders.length;
  const totalOrderValue = paidOrders.reduce((sum, o) => sum + o.totalAmount, 0);

  // chart
  const chartData = useMemo(() => {
    const sorted = [...paidOrders].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );

    return {
      labels: sorted.map((o) => new Date(o.createdAt).toLocaleDateString()),
      datasets: [
        {
          label: "Paid Orders Amount",
          data: sorted.map((o) => o.totalAmount),
          borderColor: "rgba(75,192,192,1)",
          backgroundColor: "rgba(75,192,192,0.2)",
        },
      ],
    };
  }, [paidOrders]);

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Paid Orders Over Time" },
    },
  };

  return (
    <div className="main_wrp">
      {loading ? (
        <Loading />
      ) : (
        <div className="h_profile_head">
          <div className="h_hed_sec a">
            <span>
              <h4 style={{ color: "rgba(82, 67, 217" }}>{totalOrderValue}</h4>
              <p>Total Value (AED) </p>
            </span>
            <span>
              <div className="h_i_in aa">
                <TbPigMoney size={22} />
              </div>
            </span>
          </div>
          <Link to={"/products"}>
            <div className="h_hed_sec b">
              <span>
                <h4 style={{ color: "rgba(247, 193, 46)" }}>{totalProduct}</h4>
                <small>Total Products</small>
              </span>
              <span>
                <div className="h_i_in bb ">
                  <FaShoppingCart size={22} />
                </div>
              </span>
            </div>{" "}
          </Link>
          <div className="h_hed_sec c">
            <span>
              <h4>{totalOrders}</h4>
              <p>Total Orders</p>
            </span>
            <span>
              <div className="h_i_in cc">
                <FaBoxes size={22} />
              </div>
            </span>
          </div>
          {/* <div className="h_hed_sec d">
            <span>
              <h4>{totalOrderValue}</h4>
              <p>Total Value (AED) </p>
            </span>
            <span>
              <div className="h_i_in dd">
                <FaMoneyBillTrendUp size={17} />
              </div>
            </span>
          </div> */}
        </div>
      )}
      <div className="chart_wrp">
        <Line data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default TopDashboard;
